import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f45142c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "back-icon" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "返回登录", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "welcome" }, [
  /*#__PURE__*/_createElementVNode("div", null, "欢迎您！"),
  /*#__PURE__*/_createElementVNode("div", null, "注册航天宏图大气试用账号！")
], -1))
const _hoisted_6 = { class: "main-center-form" }
const _hoisted_7 = { class: "main-center-form-main" }
const _hoisted_8 = { class: "main-center-form-account item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "account-name item-name" }, "账号区域：", -1))
const _hoisted_10 = { class: "account-main" }
const _hoisted_11 = { class: "main-center-form-province" }
const _hoisted_12 = { class: "main-center-form-city" }
const _hoisted_13 = { class: "main-center-form-county" }
const _hoisted_14 = { class: "main-center-form-unit item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit-name item-name" }, "使用组织：", -1))
const _hoisted_16 = { class: "unit-main" }
const _hoisted_17 = { class: "main-center-form-people item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "people-name item-name" }, "用户：", -1))
const _hoisted_19 = { class: "people-main" }
const _hoisted_20 = { class: "main-center-form-people item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "people-name item-name" }, "密码：", -1))
const _hoisted_22 = { class: "people-main" }
const _hoisted_23 = { class: "main-center-form-time item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "time-name item-name" }, "试用时间：", -1))
const _hoisted_25 = { class: "time-main" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("1个月")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("2个月")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("3个月")
const _hoisted_29 = { class: "time-name-txt" }
const _hoisted_30 = { class: "main-center-form-phone item" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "phone-name item-name" }, "手机号/账号：", -1))
const _hoisted_32 = { class: "phone-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Option = _resolveComponent("Option")!

  return (_openBlock(), _createElementBlock("div", {
    class: "pc-page",
    style: _normalizeStyle({
    backgroundImage: `url(${_ctx.loginBg})`,
    backgroundRepeat: 'no-repeat',
  })
  }, [
    _createElementVNode("div", {
      class: "page-title",
      style: _normalizeStyle({
      backgroundImage: 'url(' + _ctx.sysConfig.loginTitleBg + ')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100%',
    })
    }, null, 4),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "back-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toLogin && _ctx.toLogin(...args)))
      }, _hoisted_4),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Select, {
                  "filter-option": _ctx.filterOption,
                  "show-search": "",
                  value: _ctx.selectValue.province,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectValue.province) = $event)),
                  onChange: _ctx.handleChangeProvince,
                  options: _ctx.provinceDataArr
                }, null, 8, ["filter-option", "value", "onChange", "options"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_Select, {
                  "filter-option": _ctx.filterOption,
                  "show-search": "",
                  value: _ctx.selectValue.city,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectValue.city) = $event)),
                  onChange: _ctx.handleChangeCity,
                  options: _ctx.cityDataArr
                }, null, 8, ["filter-option", "value", "onChange", "options"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Select, {
                  "filter-option": _ctx.filterOption,
                  "show-search": "",
                  value: _ctx.selectValue.county,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectValue.county) = $event)),
                  options: _ctx.countyDataArr
                }, null, 8, ["filter-option", "value", "options"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_Input, {
                placeholder: "请输入组织名",
                value: _ctx.selectValue.company,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectValue.company) = $event))
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_Input, {
                placeholder: "建议输入真实姓名",
                value: _ctx.selectValue.applicant,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectValue.applicant) = $event))
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_Input, {
                placeholder: "请输入10位密码(字母+数字)",
                value: _ctx.selectValue.pwd,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectValue.pwd) = $event))
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_Select, {
                value: _ctx.selectValue.time,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectValue.time) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Option, { value: 1 }, {
                    default: _withCtx(() => [
                      _hoisted_26
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Option, { value: 2 }, {
                    default: _withCtx(() => [
                      _hoisted_27
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Option, { value: 3 }, {
                    default: _withCtx(() => [
                      _hoisted_28
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _createElementVNode("span", _hoisted_29, "根据试用时间，账号截止时间为 " + _toDisplayString(_ctx.moment().add(_ctx.selectValue.time, 'months').format('YYYY-MM-DD')) + " ，具体以审核结果为准。 ", 1)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_Input, {
                placeholder: "请输入手机号/账号",
                value: _ctx.selectValue.applicantMobile,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectValue.applicantMobile) = $event))
              }, null, 8, ["value"])
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: "main-center-form-btn",
          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.submitData && _ctx.submitData(...args)))
        }, "提交审核")
      ])
    ])
  ], 4))
}